'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Components


// Utils


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

var _Element = require('../element/Element');

var _Element2 = _interopRequireDefault(_Element);

var _gridUtils = require('../utils/grid/gridUtils');

var _elementSelector = require('../element/elementSelector');

require('./CanvasElement.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DISABLE_DRAG_CLASS_NAME = 'disable-drag';

var makeMapStateToProps = function makeMapStateToProps() {
    return function (state, ownProps) {
        return {
            element: (0, _elementSelector.getElement)(state, ownProps)
        };
    };
};

var CanvasElement = (_dec = (0, _reactRedux.connect)(makeMapStateToProps), _dec(_class = function (_React$Component) {
    _inherits(CanvasElement, _React$Component);

    function CanvasElement() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CanvasElement);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CanvasElement.__proto__ || Object.getPrototypeOf(CanvasElement)).call.apply(_ref, [this].concat(args))), _this), _this.disableDrag = function () {
            if (!_this.canvasElementDiv) return;
            _this.canvasElementDiv.classList.add(DISABLE_DRAG_CLASS_NAME);
        }, _this.enableDrag = function () {
            if (!_this.canvasElementDiv) return;
            _this.canvasElementDiv.classList.remove(DISABLE_DRAG_CLASS_NAME);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CanvasElement, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                element = _props.element,
                gridSize = _props.gridSize,
                sortIndex = _props.sortIndex;


            var canvasSize = {
                x: (0, _gridUtils.gridPointsToPixels)(element.getIn(['location', 'position', 'x']), gridSize),
                y: (0, _gridUtils.gridPointsToPixels)(element.getIn(['location', 'position', 'y']), gridSize)
            };

            var style = {
                top: canvasSize.y + 'px',
                left: canvasSize.x + 'px',
                zIndex: sortIndex
            };

            return _react2.default.createElement(
                'div',
                { 'data-element-id': element.get('id'), className: 'CanvasElement', style: style,
                    ref: function ref(c) {
                        _this2.canvasElementDiv = c;
                    } },
                _react2.default.createElement(_Element2.default, _extends({}, this.props, { disableDrag: this.disableDrag, enableDrag: this.enableDrag }))
            );
        }
    }]);

    return CanvasElement;
}(_react2.default.Component)) || _class);


CanvasElement.propTypes = {
    elementId: _propTypes2.default.string.isRequired,
    element: _propTypes2.default.object,
    gridSize: _propTypes2.default.number.isRequired,
    connectDragSource: _propTypes2.default.func,
    onDrop: _propTypes2.default.func,
    isDragging: _propTypes2.default.bool,
    sortIndex: _propTypes2.default.number
};

// Wrap the canvas element so it can be used in the document mode calculations
exports.default = (0, _recompose.pure)(CanvasElement);


//////////////////
// WEBPACK FOOTER
// ./src/client/canvas/CanvasElement.js
// module id = 1687
// module chunks = 0